/** Те же пределы, что проверяет бэкенд (PlatformValidator). */
export const MAX_PHRASES = 8;
export const MAX_PHRASE_LENGTH = 24;

export type PhraseError = "empty" | "tooLong";

export const PHRASE_ERROR_KEYS: Record<PhraseError, string> = {
  empty: "liveReactionsSettings.errors.empty",
  tooLong: "liveReactionsSettings.errors.tooLong",
};

export function phraseError(phrase: string): PhraseError | null {
  const value = phrase.trim();
  if (!value) return "empty";
  if (value.length > MAX_PHRASE_LENGTH) return "tooLong";
  return null;
}

export function normalizePhrases(phrases: string[]): string[] {
  return phrases
    .map((phrase) => phrase.trim())
    .filter(Boolean)
    .slice(0, MAX_PHRASES);
}
